import React from 'react';
import { createConnect } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import SideNavScreen from "../support/SideNavScreen.js";
import { jsx as _jsx } from "react/jsx-runtime";
const CLIENT = 'SettingsScreen';
const matchContext = {
  use: 'navBar',
  client: CLIENT
};
const {
  t
} = I18N.ns('molten.screens.settings');
class SettingsScreen extends React.Component {
  getContext = () => {
    return {
      client: CLIENT,
      clientProps: this.props
    };
  };
  render() {
    return /*#__PURE__*/_jsx(SideNavScreen, {
      title: t('title'),
      client: CLIENT,
      routeKey: CLIENT,
      routeMatch: {
        client: CLIENT
      },
      context: this.getContext(),
      matchContext: matchContext
    });
  }
}
const connect = createConnect(CLIENT, {
  client: CLIENT
});
export default connect()(SettingsScreen);